import { useQuery, QueryObserverBaseResult } from "react-query"
import { queryKeys } from "../../query"
import api, { createUrlParams } from "../../client"
import { AddressBookListResponseData, GetAddressBookListRequestQuery } from "../../types/address-book"

const getData = async (query: GetAddressBookListRequestQuery) => {
  try {
    const { data } = await api.get(`/address-book${createUrlParams(query)}`)
    return data
  } catch ({ response: { data } }) {
    return data
  }
}

export const useAddressBookList = (query: GetAddressBookListRequestQuery):
  QueryObserverBaseResult<AddressBookListResponseData> => {
  const { data, ...props } = useQuery<AddressBookListResponseData>(
    queryKeys.ADDRESS_BOOK_PAGE(query),
    () => getData(query),
  )
  return { data, ...props }
}
